import MobileTaskDetailedViewLoader from './MobileTaskDetailedViewLoader'
export default MobileTaskDetailedViewLoader
